import {
  Box,
  Heading,
  Slider,
  SliderTrack,
  SliderThumb,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { unformatDollarString } from "utils/helpers";

export const BoundsText = ({ val }: { val: string }) => {
  return (
    <Text fontSize="11px" lineHeight="15px" fontWeight="500" mb="5px" mt="4px">
      {val}
    </Text>
  );
};

const LoanCalculatorField = ({
  label,
  min,
  max,
  value,
  step,
  formatter,
  onChange,
}: {
  label: string;
  min: number;
  max: number;
  value: number;
  step: number;
  formatter: (val: number) => string;
  onChange: (val: number) => void;
}) => {
  return (
    <FormControl textAlign="center">
      <FormLabel textAlign="center" fontWeight="600" fontSize="15px" m="0px">
        {label}
      </FormLabel>
      <Input
        w="fit-content"
        h="auto"
        textAlign="center"
        type="text"
        py="4px"
        value={formatter(value)}
        variant="flushed"
        onChange={(ev) => onChange(unformatDollarString(ev.target.value))}
      />
      <Flex justifyContent="space-between">
        <BoundsText val={formatter(min)} />
        <BoundsText val={formatter(max)} />
      </Flex>
      <Slider
        value={value}
        min={min}
        max={max}
        step={step}
        mb="10px"
        aria-label="slider-ex-6"
        onChange={onChange}
      >
        <SliderTrack height="5px" bg="#E2DFE8" />
        <SliderThumb
          boxSize="15"
          borderWidth="3px"
          borderColor="primary"
          boxShadow="none"
        />
      </Slider>
    </FormControl>
  );
};

export const dollarFormatter = (val: number) => {
  return `$${val ? val.toLocaleString() : "0"}`;
};

export const percentFormatter = (val: number) => {
  return `${val ? val.toLocaleString() : "0"}%`;
};

export default function LoanCalculator({
  onChange,
}: {
  onChange: (values: any) => void;
}) {
  // const ranges = ;

  // const [sliderValue, setSliderValue] = useState(ranges.amount.default);

  const [ranges, setRanges] = useState({
    amount: {
      value: 500000,
      min: 500000,
      max: 10000000,
    },
    origination: {
      value: 0,
      min: 0,
      max: 5,
    },
    interest: {
      value: 3,
      min: 3,
      max: 30,
    },
    term: {
      value: 3,
      min: 3,
      max: 60,
    },
    ratio: {
      value: 0,
      min: 0,
      max: 100,
    },
  });

  useEffect(() => {
    onChange(ranges);
  }, [ranges]);

  // https://chakra-ui.com/docs/components/number-input#combining-it-with-a-slider

  return (
    <Box flex="1" bg="white" borderRadius="20px" py="17px" px="25px">
      <Heading fontWeight="600" fontSize="20px" mb="6px">
        Loan Calculator
      </Heading>
      <Box px="12px">
        <LoanCalculatorField
          label="Loan Amount"
          min={ranges.amount.min}
          max={ranges.amount.max}
          value={ranges.amount.value}
          step={1000}
          formatter={dollarFormatter}
          onChange={(val: number) =>
            setRanges({
              ...ranges,
              amount: {
                ...ranges.amount,
                value: val,
                // value: val < ranges.amount.min ? ranges.amount.min : val,
              },
            })
          }
        />
        <LoanCalculatorField
          label="Loan Origination Fee"
          min={ranges.origination.min}
          max={ranges.origination.max}
          value={ranges.origination.value}
          step={0.1}
          formatter={percentFormatter}
          onChange={(val: number) =>
            setRanges({
              ...ranges,
              origination: {
                ...ranges.origination,
                value: val,
                // value: val < ranges.amount.min ? ranges.amount.min : val,
              },
            })
          }
        />
        <LoanCalculatorField
          label="Interest Rate"
          min={ranges.interest.min}
          max={ranges.interest.max}
          value={ranges.interest.value}
          step={0.1}
          formatter={percentFormatter}
          onChange={(val: number) =>
            setRanges({
              ...ranges,
              interest: {
                ...ranges.interest,
                value: val,
                // value: val < ranges.amount.min ? ranges.amount.min : val,
              },
            })
          }
        />
        <LoanCalculatorField
          label="Loan Term"
          min={ranges.term.min}
          max={ranges.term.max}
          value={ranges.term.value}
          step={1}
          formatter={(val) => `${val} months`}
          onChange={(val: number) =>
            setRanges({
              ...ranges,
              term: {
                ...ranges.term,
                value: val,
                // value: val < ranges.amount.min ? ranges.amount.min : val,
              },
            })
          }
        />
        <LoanCalculatorField
          label="LTC/LTV"
          min={ranges.ratio.min}
          max={ranges.ratio.max}
          value={ranges.ratio.value}
          step={0.1}
          formatter={percentFormatter}
          onChange={(val: number) =>
            setRanges({
              ...ranges,
              ratio: {
                ...ranges.ratio,
                value: val,
                // value: val < ranges.amount.min ? ranges.amount.min : val,
              },
            })
          }
        />
      </Box>
    </Box>
  );
}
